import { motion } from "framer-motion";
import { Copy } from "lucide-react";
import { SectionHeading, reveal } from "./SectionHeading";
import { copyCA, CA } from "../lib/ca";

const MOON_IMG =
  "https://images.unsplash.com/photo-1481819434877-23b892ca68ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxoYWxsb3dlZW4lMjBoYXVudGVkJTIwZnVsbCUyMG1vb24lMjBuaWdodHxlbnwwfHx8fDE3OTE4OTcxNTl8MA&ixlib=rb-4.1.0&q=85";

const cards = [
  {
    metric: "666,666,666",
    label: "Total Haunted Supply",
    desc: "Fixed forever. No mint function, no necromancy inflation.",
    testid: "tokenomics-supply-card",
  },
  {
    metric: "100% LP",
    label: "Sent to the Underworld",
    desc: "Burnt upon launch with a verifiable transaction hash.",
    testid: "tokenomics-lp-card",
  },
  {
    metric: "0% / 0%",
    label: "Tax Policy",
    desc: "Pure memetic velocity for instant FOMO app traders.",
    testid: "tokenomics-tax-card",
  },
  {
    metric: "LIVE NOW",
    label: "Contract Address",
    desc: "Deployed and verified. Always cross-check the address before you ape in.",
    testid: "tokenomics-ca-card",
  },
];

export default function Tokenomics() {
  return (
    <section
      id="tokenomics"
      data-testid="tokenomics-section"
      className="relative overflow-hidden px-6 py-28 sm:px-12 sm:py-36"
    >
      <img
        src={MOON_IMG}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-35 mix-blend-screen"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-abyss via-transparent to-abyss" />

      <div className="relative mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Chapter II // Graveyard Tokenomics"
          title="Buried Numbers,"
          accent="Honest Magic"
          description="No hidden vaults, no dev bags in the attic. The spell is simple and fully verifiable on-chain."
          testid="tokenomics-heading"
        />

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {cards.map((c, i) => (
            <motion.div
              key={c.label}
              data-testid={c.testid}
              {...reveal(i * 0.08)}
              className="crypt-card bg-abyss/80 backdrop-blur-sm"
            >
              <p className="font-cinzel text-3xl font-black text-pumpkin">{c.metric}</p>
              <p className="mt-2 font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-orange-400/80">
                {c.label}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-zinc-400">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          {...reveal(0.35)}
          className="mt-10 flex flex-col items-start justify-between gap-5 rounded-2xl border border-dashed border-orange-500/40 bg-abyss/80 p-6 backdrop-blur-sm sm:flex-row sm:items-center sm:p-8"
        >
          <div>
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.3em] text-orange-400/80">
              Official Contract Address
            </p>
            <p className="mt-2 break-all font-mono text-sm font-semibold tracking-wider text-zinc-100 sm:text-base">
              {CA}
            </p>
          </div>
          <button
            data-testid="tokenomics-copy-ca-btn"
            onClick={copyCA}
            className="flex items-center gap-2 rounded-full bg-pumpkin px-6 py-3 font-syne text-xs font-bold uppercase tracking-widest text-abyss transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_25px_rgba(255,107,0,0.5)]"
          >
            <Copy size={14} /> Copy Contract Address
          </button>
        </motion.div>
      </div>
    </section>
  );
}
